import { render, staticRenderFns } from "./GraphDespesas.vue?vue&type=template&id=6571f25d&scoped=true&"
import script from "./GraphDespesas.vue?vue&type=script&lang=js&"
export * from "./GraphDespesas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6571f25d",
  null
  
)

export default component.exports